module.exports = __webpack_public_path__ + "img/bm-5.b6113c4f.png";